export const USER_SET_ERROR = 'USER_SET_ERROR';
export const USER_RESET = 'USER_RESET';
export const USER_SET_LOADING = 'USER_SET_LOADING';
export const USER_SET_USER = 'USER_SET_USER';
export const USER_SET_USERS = 'USER_SET_USERS';

export const USER_SET_TOKEN = 'USER_SET_TOKEN';
export const USER_SET_USERID = 'USER_SET_USERID';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_STASH_ADMIN = 'USER_STASH_ADMIN';
export const USER_CLEAR_ADMIN_STASH = 'USER_CLEAR_ADMIN_STASH';
